<template>
  <div>
    <el-card>
      <div class="add_box">
        <el-form
          :model="this.list"
          :rules="toEdRule"
          :label-position="labelPosition"
          ref="ruleForm"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="活动名称" prop="title">
                <el-input
                  placeholder="请输入内容"
                  v-model="list.title"
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <el-form-item label="是否轮播" prop="isRotation">
                <el-select
                  placeholder="请选择"
                  v-model="list.isRotation"
                  clearable
                >
                  <el-option
                    v-for="item in homeLun"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="感兴趣人数" prop="interestingCount">
                <el-input
                  style="width: 220px"
                  placeholder="请输入内容"
                  v-model="list.interestingCount"
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <el-form-item label="开始时间" prop="startDate">
                <el-date-picker
                  v-model="list.startDate"
                  type="date"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="结束时间" prop="startDate">
                <el-date-picker
                  v-model="list.endDate"
                  type="date"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="18">
              <el-form-item label="主办单位" prop="organizer">
                <el-input
                  placeholder="请输入内容"
                  v-model="list.organizer"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="18">
              <el-form-item label="地址" prop="address">
                <el-input
                  placeholder="请输入内容"
                  v-model="list.address"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="封面图" prop="coverUrl" ref="coverUrl">
                <el-upload
                  class="avatar-uploader1"
                  :action="serverUrl"
                  :headers="header"
                  name="img"
                  :auto-upload="true"
                  :show-file-list="false"
                  :on-success="upSuccess"
                >
                  <img
                    v-if="list.coverUrl"
                    :src="list.coverUrl"
                    class="avatar"
                    style="width: 250px; height: auto"
                  />

                  <i
                    :class="
                      loadUpt
                        ? 'el-icon-loading'
                        : 'el-icon-plus avatar-uploader-icon'
                    "
                    style="margintop: 10px; font-size: 50px"
                    v-else
                  ></i>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <!-- 内容区 -->
            <el-form-item
              label="内容"
              prop="content"
              style="min-width: 1000px"
              ref="contentext"
            >
              <el-upload
                :action="serverUrl"
                :before-upload="beforeUpload"
                :headers="header"
                :on-error="uploadError"
                :on-success="uploadSuccess"
                :show-file-list="false"
                class="avatar-uploader"
                name="img"
              ></el-upload>
              <quill-editor
                :options="editorOption"
                @change="onEditorChange($event)"
                ref="myTextEditor"
                style="width: 100%; height: 800px; padding-bottom: 100px"
                v-model="list.content"
              ></quill-editor>
              <div :visible.sync="videoUploadTag">
                <el-dialog
                  :visible.sync="videoUploadTag"
                  append-to-body
                  id="video_upload"
                  title="视频上传"
                  width="100%"
                >
                  <el-tabs style="margin-top: 0px">
                    <el-tab-pane label="添加视频链接" name="first">
                      <el-input
                        clearable
                        placeholder="请输入视频链接"
                        v-model="videoLink"
                      ></el-input>
                      <el-button
                        @click="addVideoLink()"
                        size="small"
                        style="margin: 20px 0px 0px 0px"
                        type="primary"
                        >添加</el-button
                      >
                    </el-tab-pane>
                    <el-tab-pane label="上传本地视频" name="second"
                      ><a-upload
                        list-type="picture"
                        :action="serverUrl"
                        name="img"
                        :headers="header"
                        :supportServerRender="true"
                        @change="videoChange"
                      >
                        <a-button> <a-icon type="upload" /> 上传视频 </a-button>
                      </a-upload></el-tab-pane
                    >
                  </el-tabs>
                </el-dialog>
              </div>
            </el-form-item>
          </el-row>
          <el-row>
            <el-button
              style="margin-left: 600px"
              type="primary"
              @click="submitEdit('ruleForm')"
              >保存</el-button
            >
          </el-row>
        </el-form>
      </div>
    </el-card>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import VideoBlot from "../../utils/video.js";
Quill.register(VideoBlot);

const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
  ["blockquote", "code-block"], // 引用  代码块
  [{ header: 1 }, { header: 2 }], // 1、2 级标题
  [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
  [{ script: "sub" }, { script: "super" }], // 上标/下标
  [{ indent: "-1" }, { indent: "+1" }], // 缩进
  // [{'direction': 'rtl'}],                         // 文本方向
  [{ size: ["8px", "small", false, "large", "huge"] }], // 字体大小
  //   [{ size: ["10px", false, "16px", "18"]}], // 字体大小
  [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
  [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
  [{ font: [] }], // 字体种类
  [{ align: [] }], // 对齐方式
  ["clean"], // 清除文本格式
  ["link", "image", "video"], // 链接、图片、视频
];
import { baseURL } from "../../api/config";
export default {
  props: ["Changedata"],
  components: { quillEditor },
  data() {
    var self2 = this;
    return {
      loadUpt: false,
      myHeaders: { token: this.$store.state.token },
      serverUrl: baseURL + "/file/uploadFile",
      header: {
        token: localStorage.getItem("key"),
      },
      myHeaders: { token: this.$store.state.token },
      //显示插入视频链接弹框的标识
      videoUploadTag: false,
      //弹框插入的视频链接记录
      videoLink: "",
      quillUpdateImg: false, // 根据图片上传状态来确定是否显示loading动画，刚开始是false,不显示
      list: [],
      editorOption: {
        placeholder: "请输入...",
        theme: "snow",
        modules: {
          toolbar: {
            container: toolbarOptions,
            handlers: {
              image: function (value) {
                if (value) {
                  document.querySelector(".avatar-uploader input").click();
                } else {
                  this.quill.format("image", false);
                }
              },
              video: function (value) {
                if (value) {
                  self2.videoUploadTag = true;
                } else {
                  this.quill.format("image", false);
                }
              },
            },
          },
        },
      },
      labelPosition: "top",
      toEdRule: {
        title: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        interestingCount: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        coverUrl: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        organizer: [
          { required: true, message: "内容不能为空", trigger: "change" },
        ],
        startDate: [
          { required: true, message: "内容不能为空", trigger: "change" },
        ],
        endDate: [
          { required: true, message: "内容不能为空", trigger: "change" },
        ],
        isRotation: [
          { required: true, message: "内容不能为空", trigger: "change" },
        ],
        address: [
          {
            required: true,
            message: "内容不能为空",
            trigger: "change",
          },
        ],
        content: [
          { required: true, message: "内容不能为空", trigger: "change" },
        ],
      },
      //是否轮播--下拉框：
      homeLun: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "不是",
        },
      ],
    };
  },
  methods: {
    upSuccess(file) {
      this.list.coverUrl = file.entity;
      if (file.entity) {
        this.$refs.coverUrl.clearValidate();
      }
    },
    //富文本图片上传前
    beforeUpload() {
      this.quillUpdateImg = true;
    },
    uploadSuccess(res, file) {
      let quill = this.$refs.myTextEditor.quill;
      //如果上传成功
      if (res.statusCode == 200) {
        // 获取光标所在位置
        let length = quill.getSelection().index;
        // 插入图片 res.url为服务器返回的图片地址
        quill.insertEmbed(length, "image", res.entity);
        // 调整光标到最后
        quill.setSelection(length + 1);
      } else if (!res.success && res.statusCode == "401") {
        // alert(res.message);
        this.$message.error(res.message);
        this.$router.push("/");
      } else if (res.success == false) {
        this.$message.error(res.message);
      }
      //loading动画消失
      this.quillUpdateImg = false;
    },
    //富文本编辑改变事件
    onEditorChange({ editor, html, text }) {
      //   console.log(html, "----");
      this.list.content = html;
    },
    // 上传本地视频
    videoChange(file, fileList, event) {
      this.insertEle("video", file.file.response.entity); //方法，插入图片到富文本
    },
    insertEle(type, url) {
      let quill = this.$refs.myTextEditor.quill;
      //  当编辑器中没有输入文本时，这里获取到的 range 为 null
      var range = this.$refs.myTextEditor.quill.getSelection();
      // 视频插入在富文本中的位置
      var index = 0;
      if (range == null) {
        index = 0;
      } else {
        index = range.index;
      }
      // 插入视频  response.data.url为服务器返回的图片地址
      if (type === "video") {
        this.$refs.myTextEditor.quill.insertEmbed(index, "simpleVideo", {
          url,
          controls: "controls",
          width: "100%",
          height: "200px",
          poster: url + "?x-oss-process=video/snapshot,t_1,f_jpg,m_fast",
        });
      }
      // 调整光标到最后
      this.$refs.myTextEditor.quill.setSelection(index + 1);
      this.videoUploadTag = false;
    },
    //富文本图片上传失败
    uploadError() {
      // loading动画消失
      this.quillUpdateImg = false;
      this.$message.error("图片插入失败");
    },
    // 添加视频
    addVideoLink(type) {
      if (this.videoLink.length == 0) {
        alert("请输入视频链接");
      }
      //当编辑器中没有输入文本时，这里获取到的 range 为 null
      var range = this.$refs.myTextEditor.quill.getSelection();
      //视频插入在富文本中的位置
      var index = 0;
      if (range == null) {
        index = 0;
      } else {
        index = range.index;
      }
      //隐藏弹框
      this.videoUploadTag = false;
      //将视频链接插入到当前的富文本当中
      ///以引号分隔嵌入的视频代码 如下图中有分析
      var list = this.videoLink;
      let data = list.split(" ");
      let obj = {};
      var str = "==";
      data.map((item) => (obj[item.split("=")[0]] = item.split("=")[1] || ""));
      var url = obj.src + str;
      var urlName = url.slice(1);
      this.$refs.myTextEditor.quill.insertEmbed(index, "video", urlName);
    },
    //将中国标准时间转换为年月日格式  ----开始
    formatTen(num) {
      return num > 9 ? num + "" : "0" + num;
    },
    formatDate(date) {
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hour = date.getHours();
      var minute = date.getMinutes();
      var second = date.getSeconds();
      return year + "-" + this.formatTen(month) + "-" + this.formatTen(day);
    },
    submitEdit(formName) {
      this.$refs[formName].validate((valid) => {
        var startDate = this.formatDate(new Date(this.list.startDate));
        var endDate = this.formatDate(new Date(this.list.endDate));
        this.postAxios("/callup/update", {
          id: this.list.id,
          coverUrl: this.list.coverUrl,
          title: this.list.title,
          organizer: this.list.organizer,
          content: this.list.content,
          address: this.list.address,
          startDate: startDate,
          endDate: endDate,
          isRotation: this.list.isRotation,
          interestingCount: this.list.interestingCount,
        }).then((res) => {
          if (res.success) {
            this.$message.success(res.message);
          } else if (res.success == false) {
            this.$message.error(res.message);
          } else if (res.success == false && res.statusCode == "401") {
            this.$message.error(res.message);
            this.$router.push("/");
          }
        });
      });
    },
  },
  mounted() {
    this.list = this.Changedata;
    console.log(this.list, "----");
  },
  watch: {
    Changedata(newVal, oldVal) {
      this.list = newVal;
    },
  },
};
</script>
<style scoped lang="less">
/deep/.el-dialog {
  margin-top: 0 !important;
}
/deep/ .el-icon-close {
  font-size: 38px;
  font-weight: bold;
}
</style>